(function () {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  function pageLang() {
    return document.documentElement.lang || 'en';
  }

  function formatDate(date) {
    try {
      return new Intl.DateTimeFormat(pageLang(), { day: 'numeric', month: 'long' }).format(date);
    } catch (error) {
      return MONTHS[date.getMonth()] + ' ' + ordinal(date.getDate());
    }
  }

  function ordinal(day) {
    if (day >= 11 && day <= 13) return day + 'th';
    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initGallery(root) {
    var main = root.querySelector('[data-main]');
    var thumbsTrack = root.querySelector('[data-thumbs]');
    if (!main) return;
    var slides = main.children;
    var thumbs = thumbsTrack ? thumbsTrack.querySelectorAll('[data-index]') : [];
    var current = 0;

    function slideWidth() {
      if (slides.length < 2) return main.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function markThumb(index) {
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (thumbsTrack && thumbs[index]) {
        thumbsTrack.scrollTo({ left: thumbs[index].offsetLeft - thumbs[0].offsetLeft });
      }
    }

    function goTo(index) {
      var total = slides.length;
      current = ((index % total) + total) % total;
      main.scrollTo({ left: current * slideWidth() });
      markThumb(current);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var settle = null;
    main.addEventListener(
      'scroll',
      function () {
        window.clearTimeout(settle);
        settle = window.setTimeout(function () {
          var index = Math.round(main.scrollLeft / slideWidth());
          if (index !== current) {
            current = Math.max(0, Math.min(slides.length - 1, index));
            markThumb(current);
          }
        }, 120);
      },
      { passive: true }
    );

    main.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(current + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(current - 1);
      }
    });
  }

  function initBuyBox(root) {
    var form = root.querySelector('form.custom-offer__form');
    if (!form) return;
    var bundles = form.querySelectorAll('.custom-offer__bundle');
    var button = form.querySelector('[data-add-button]');
    var buttonLabel = form.querySelector('[data-button-label]');
    var buttonPrice = form.querySelector('[data-button-price]');
    var buttonCompare = form.querySelector('[data-button-compare]');
    var buttonCompareValue = form.querySelector('[data-button-compare-value]');
    var errorBox = form.querySelector('[data-error]');
    var busy = false;

    function update() {
      var checked = form.querySelector('input[name="id"]:checked');
      bundles.forEach(function (bundle) {
        var input = bundle.querySelector('input[name="id"]');
        var selected = input === checked;
        bundle.classList.toggle('is-selected', selected);
        if (selected) {
          buttonPrice.textContent = bundle.dataset.price;
          if (bundle.dataset.compare) {
            buttonCompareValue.textContent = bundle.dataset.compare;
            buttonCompare.hidden = false;
          } else {
            buttonCompareValue.textContent = '';
            buttonCompare.hidden = true;
          }
          var available = bundle.dataset.available === 'true';
          button.disabled = !available;
          buttonLabel.textContent = available ? button.dataset.label : button.dataset.soldOut;
        }
      });
      if (errorBox) errorBox.hidden = true;
    }

    form.addEventListener('change', function (event) {
      if (event.target.name === 'id') update();
    });

    function reset() {
      busy = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      update();
    }

    function showError(message) {
      reset();
      if (!errorBox) return;
      errorBox.textContent = message || errorBox.dataset.message || 'Algo salió mal. Vuelve a intentarlo.';
      errorBox.hidden = false;
    }

    function post(url, body) {
      return fetch(rootUrl() + url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
      }).then(function (response) {
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            if (!response.ok) {
              var error = new Error('Cart request failed');
              error.userMessage = data && typeof data.description === 'string' ? data.description : '';
              throw error;
            }
            return data;
          });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var checked = form.querySelector('input[name="id"]:checked');
      if (busy || !checked || button.disabled) return;
      busy = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
      var behaviour = form.dataset.behaviour || 'checkout_clear';
      var item = { items: [{ id: parseInt(checked.value, 10), quantity: 1 }] };
      var chain = behaviour === 'checkout_clear' ? post('cart/clear.js') : Promise.resolve();
      chain
        .then(function () {
          return post('cart/add.js', item);
        })
        .then(function () {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'custom-product-offer' });
          }
          window.location.href = behaviour === 'cart' ? rootUrl() + 'cart' : rootUrl() + 'checkout';
        })
        .catch(function (error) {
          showError(error && error.userMessage);
        });
    });

    window.addEventListener('pageshow', reset);
    update();
  }

  function initDeliveryDate(root) {
    root.querySelectorAll('[data-delivery-days]').forEach(function (line) {
      var target = line.querySelector('[data-delivery-date]');
      if (!target) return;
      var days = parseInt(line.dataset.deliveryDays, 10) || 0;
      var date = new Date();
      date.setDate(date.getDate() + days);
      target.textContent = ' ' + formatDate(date);
    });
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-sticky]');
    var area = root.querySelector('[data-offer-area]');
    var buy = root.querySelector('.custom-offer__buy');
    if (!bar || !area) return;
    var footer = document.querySelector('.custom-footer, footer.shopify-section');
    var frame = null;

    function check() {
      frame = null;
      var pastOffer = area.getBoundingClientRect().bottom <= 0;
      var beforeFooter = !footer || footer.getBoundingClientRect().top > window.innerHeight;
      var visible = pastOffer && beforeFooter;
      bar.classList.toggle('is-visible', visible);
      var padding = visible && bar.offsetHeight ? bar.offsetHeight + 'px' : '';
      if (document.documentElement.style.scrollPaddingBottom !== padding) {
        document.documentElement.style.scrollPaddingBottom = padding;
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!frame) frame = window.requestAnimationFrame(check);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      if (!frame) frame = window.requestAnimationFrame(check);
    });

    bar.querySelector('[data-sticky-button]').addEventListener('click', function () {
      (buy || area).scrollIntoView({ block: 'start' });
      var radio =
        root.querySelector('input[name="id"]:checked:not([disabled])') || root.querySelector('input[name="id"]:not([disabled])');
      if (radio) radio.focus({ preventScroll: true });
    });

    check();
  }

  function init(root) {
    if (!root || root.dataset.customOfferReady) return;
    root.dataset.customOfferReady = 'true';
    initGallery(root);
    initBuyBox(root);
    initDeliveryDate(root);
    initSticky(root);
  }

  function initAll() {
    document.querySelectorAll('[data-custom-offer]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-custom-offer]'));
  });
})();